import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { store, httpClient } from './model/store';
import SocialServices, { FACEBOOK_SERVICE, TWITTER_SERVICE } from '../utils/socialServices';

const MENU_BTN_ID_BASE = 'navCollapseBtn';
const MENU_BTN_ID = '#' + MENU_BTN_ID_BASE;
const NAVBAR_COLLAPSE_ID_BASE = 'navbar-collapse-1';
const NAVBAR_COLLAPSE_ID = '#' + NAVBAR_COLLAPSE_ID_BASE;

export default class Header extends React.Component {
	constructor() {
		super();

		this.socialServices = new SocialServices({
			onSetProgress: b => {
				console.info(`Main.socialServices.onSetProgress(${b});`);
			},
			httpClient: httpClient,
			config: store.getState().config.social,
		});
	}

	componentWillUnmount() {
		if (this.socialServices) {
			this.socialServices.destroy();
			this.socialServices = null;
		}
	}

	socialClick(service) {
		console.info(`Header.onSocialClick(${service});`);

		switch (service) {
			case FACEBOOK_SERVICE: {
				//this.socialServices.socialClick({ message: '', service: FACEBOOK_SERVICE });
				this.socialServices.shareFBMainPage();
				break;
			}
			case TWITTER_SERVICE:
				this.socialServices.socialClick({ message: '', service: TWITTER_SERVICE });
				break;
			default:
				break;
		}
	}

	render() {
		const { location } = this.props;

		return (
			<nav class="navbar navbar-inverse navbar-fixed-top">
				<div class="container-fluid navbar-container">
					<div class="navbar-header clearfix">
						<button
							id={MENU_BTN_ID_BASE}
							type="button"
							class="navbar-toggle collapsed  clearfix"
							data-toggle="collapse"
							data-target={NAVBAR_COLLAPSE_ID}
							aria-expanded="false"
						>
							<span class="sr-only">Toggle navigation</span>
							<span class="icon-bar" />
							<span class="icon-bar" />
							<span class="icon-bar" />
						</button>
						<NavLink class="navbar-brand" to="/">
							<img
								src="/img/bham-logo.png"
								class="img-responsive"
								alt="Hellobeautiful Women To Know logo"
							/>
						</NavLink>
					</div>
					<div class="collapse navbar-collapse" id={NAVBAR_COLLAPSE_ID_BASE}></div>
				</div>
			</nav>
		);
	}
}

// <li><NavLink to="/about" class={''} activeClassName="active" onClick={console.log} >About</NavLink></li>
// <li><NavLink to="/featured" class={''} activeClassName="active" onClick={console.log} >Ceiling Breakers</NavLink></li>
// <li><NavLink to="/credits" class={''} activeClassName="active" onClick={console.log} >Credits</NavLink></li>
// <li><a ref="facebookBtn" id="facebookBtn" class="share-btn facebook" onClick={() => { this.socialClick(FACEBOOK_SERVICE); }}><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
// <li><a ref="twitterBtn" id="twitterBtn" class="share-btn twitter" onClick={() => { this.socialClick(TWITTER_SERVICE); }}><i class="fa fa-twitter" aria-hidden="true"></i></a></li>



// WEBPACK FOOTER //
// ./src/js/components/header.js